import { Parser, ParseResult } from "../types";
import { envParser } from "./envParser";
import { yamlParser } from "./yamlParser";
import { jsonParser } from "./jsonParser";

export const defaultParsers: Parser[] = [envParser, yamlParser, jsonParser];

export function parseContent(content: string, parsers: Parser[] = defaultParsers): ParseResult<Record<string, unknown>> {
  const sortedParsers = [...parsers].sort((a, b) => a.priority - b.priority);

  for (const parser of sortedParsers) {
    const result = parser.parse(content);
    if (result.success) {
      return result;
    }
  }

  return {
    success: false,
    data: null,
    format: "unknown",
    error: "Could not parse file. Supported formats: ENV, YAML, JSON",
  };
}

export { envParser, yamlParser, jsonParser };
